// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalendarOutlinedSvg from "@ant-design/icons-svg/es/asn/CalendarOutlined";
import AntdIcon from '../components/AntdIcon';

var CalendarOutlined = function CalendarOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalendarOutlinedSvg
  }));
};

CalendarOutlined.displayName = 'CalendarOutlined';
export default /*#__PURE__*/React.forwardRef(CalendarOutlined);